import http from "../http-common";

class WildlifeDataService {
    create(data) {
        return http.post("/wildlife", data);
    }

    getByDate(date) {
        return http.get(`/wildlife/${date}`);
    }

    getByDateAndTripGroup(date, tripGroupId) {
        console.log(`Requesting wildlife for date ${date} and group ${tripGroupId}`);
        return http.get(`/wildlife/${date}/${tripGroupId}`);
    }

    getById(id) {
        return http.get(`/wildlife/id/${id}`);
    }

    delete(id) {
        return http.delete(`/wildlife/${id}`);
    }
}

export default new WildlifeDataService();
